import React, { useState } from "react";

import {
  Box,
  List,
  ListItem,
  Drawer,
  ListItemButton,
  ListItemText,
  AppBar,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import ListItemIcon from "@mui/material/ListItemIcon";
import ManageAccountsRoundedIcon from "@mui/icons-material/ManageAccountsRounded";
import ContactEmergencyRoundedIcon from "@mui/icons-material/ContactEmergencyRounded";
import BookmarkAddRoundedIcon from "@mui/icons-material/BookmarkAddRounded";
import ExploreRoundedIcon from "@mui/icons-material/ExploreRounded";
import DriveEtaRoundedIcon from "@mui/icons-material/DriveEtaRounded";
import CardTravelRoundedIcon from "@mui/icons-material/CardTravelRounded";
import MessageTwoToneIcon from "@mui/icons-material/MessageTwoTone";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import Itinerary from "./Itinerary";
import ListBooking from "./ListBooking";
import Accommodation from "./Accommondation";
import CalendarMonthTwoToneIcon from "@mui/icons-material/CalendarMonthTwoTone";

import User from "./User";
import Vendor from "./Vendor";
import { checkAdminRole, checkOper_or_admin } from "./utils/tool";
import Operating from "./Operating";
import AddBooking from "./AddBooking";
import MessTool from "./messtool";
import CalendarMess from "./CalendarMess";

function App() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [isExpanded, setIsExpanded] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const drawerWidth = isMobile ? 240 : isExpanded ? 200 : 60;

  const styles = {
    box1: { flexGrow: 1, flex: 3, minWidth: 0, overflow: "hidden" },
    appbar: {
      width: isMobile ? "100%" : `calc(100% - ${drawerWidth}px)`,
      ml: isMobile ? 0 : `${drawerWidth}px`,
    },
    drawer: {
      width: isMobile ? 0 : drawerWidth,
      flexShrink: 0,
      "& .MuiDrawer-paper": {
        width: drawerWidth,
        boxSizing: "border-box",
        transition: "width 0.2s",
        backgroundColor: "#F8FAFC",
        borderRight: "1px solid #E8ECF0",
      },
    },
  };

  const BOOKING = "BOOKING";
  const ADD_BOOKING = "ADD_BOOKING";
  const OPERATING = "OPERATING";
  const CALENDARMESS = "CALENDARMESS";
  const ITINERARY = "ITINERARY";
  const ACCOMMODATION = "ACCOMMODATION";
  const VENDOR = "VENDOR";
  const USER = "USER";
  const MESSTOOL = "MESSTOOL";

  const [drawer_data, set_drawer_data] = useState(BOOKING);

  const showing_drawer = (state) => {
    if (state === BOOKING) {
      return <ListBooking />;
    } else if (state === ADD_BOOKING) {
      return <AddBooking />;
    } else if (state === OPERATING) {
      return <Operating />;
    } else if (state === ITINERARY) {
      return <Itinerary />;
    } else if (state === CALENDARMESS) {
      return <CalendarMess />;
    } else if (state === ACCOMMODATION) {
      return <Accommodation />;
    } else if (state === VENDOR) {
      return <Vendor />;
    } else if (state === MESSTOOL) {
      return <MessTool />;
    } else if (state === USER) {
      return <User />;
    }
  };

  function ListItemCus({ data_show, icon, titleDATA }) {
    const isActive = titleDATA === drawer_data;
    const showText = isMobile || isExpanded;
    return (
      <ListItem disablePadding sx={{ px: showText ? 1 : 0.5, mb: 0.3 }}>
        <ListItemButton
          onClick={() => set_drawer_data(titleDATA)}
          sx={{
            borderRadius: "8px",
            backgroundColor: isActive ? "#EBF4FF" : "transparent",
            borderLeft: isActive ? "3px solid #1976D2" : "3px solid transparent",
            "&:hover": {
              backgroundColor: isActive ? "#EBF4FF" : "#F0F2F5",
            },
            py: 0.8,
            minHeight: 0,
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: showText ? 36 : "auto",
              color: isActive ? "#1976D2" : "#6B7280",
            }}
          >
            {icon}
          </ListItemIcon>
          {showText && (
            <ListItemText
              primary={data_show}
              primaryTypographyProps={{
                fontSize: 14,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? "#1976D2" : "#374151",
              }}
            />
          )}
        </ListItemButton>
      </ListItem>
    );
  }

  const drawerContent = (
    <List disablePadding>
      {!isMobile && (
        <ListItem
          disablePadding
          sx={{
            borderBottom: "1px solid #E8ECF0",
            mb: 1,
          }}
        >
          <ListItemButton
            onClick={() => setIsExpanded(!isExpanded)}
            sx={{
              py: 1.5,
              justifyContent: isExpanded ? "flex-start" : "center",
            }}
          >
            <ListItemIcon sx={{ minWidth: isExpanded ? 32 : "auto", color: "#6B7280" }}>
              {isExpanded ? <ChevronLeftIcon /> : <MenuIcon />}
            </ListItemIcon>
            {isExpanded && (
              <img
                src="LOGO.jpg"
                alt="Logo"
                style={{ height: 80, objectFit: "contain" }}
              />
            )}
          </ListItemButton>
        </ListItem>
      )}

      {isMobile && (
        <ListItem
          disablePadding
          sx={{
            borderBottom: "1px solid #E8ECF0",
            mb: 1,
            justifyContent: "center",
            py: 1.5,
          }}
        >
          <img
            src="LOGO.jpg"
            alt="Logo"
            style={{ height: 60, objectFit: "contain" }}
          />
        </ListItem>
      )}

      <ListItemCus
        titleDATA={BOOKING}
        data_show="List Booking"
        icon={<BookmarkAddRoundedIcon />}
      />
      <ListItemCus
        titleDATA={ADD_BOOKING}
        data_show="Sample Booking"
        icon={<BookmarkAddRoundedIcon />}
      />
      <ListItemCus
        titleDATA={ITINERARY}
        data_show="Itinerary"
        icon={<DriveEtaRoundedIcon />}
      />
      <ListItemCus
        titleDATA={ACCOMMODATION}
        data_show="Location"
        icon={<ExploreRoundedIcon />}
      />
      {checkAdminRole() ? (
        <ListItemCus
          titleDATA={VENDOR}
          data_show="Vendor"
          icon={<ContactEmergencyRoundedIcon />}
        />
      ) : null}
      {checkOper_or_admin() ? (
        <ListItemCus
          titleDATA={OPERATING}
          data_show="Operating"
          icon={<ContactEmergencyRoundedIcon />}
        />
      ) : null}

      {checkOper_or_admin() ? (
        <ListItemCus
          titleDATA={CALENDARMESS}
          data_show="Calendar Mess"
          icon={<CalendarMonthTwoToneIcon />}
        />
      ) : null}
      {checkAdminRole() ? (
        <ListItemCus
          titleDATA={MESSTOOL}
          data_show="MessTool"
          icon={<MessageTwoToneIcon />}
        />
      ) : null}
      <ListItemCus
        titleDATA={USER}
        data_show="User"
        icon={<ManageAccountsRoundedIcon />}
      />
    </List>
  );

  return (
    <div style={{ display: "flex" }}>
      {isMobile && (
        <AppBar
          position="fixed"
          sx={{
            backgroundColor: "#1565C0",
            zIndex: theme.zIndex.drawer + 1,
          }}
        >
          <Toolbar sx={{ minHeight: "48px !important" }}>
            <IconButton
              color="inherit"
              edge="start"
              onClick={() => setMobileOpen(!mobileOpen)}
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="subtitle1" noWrap sx={{ fontWeight: 600 }}>
              {drawer_data.replace("_", " ")}
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      {isMobile ? (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={() => setMobileOpen(false)}
          ModalProps={{ keepMounted: true }}
          sx={styles.drawer}
        >
          <Box
            onClick={() => setMobileOpen(false)}
          >
            {drawerContent}
          </Box>
        </Drawer>
      ) : (
        <Drawer sx={styles.drawer} variant="permanent" anchor="left">
          {drawerContent}
        </Drawer>
      )}

      <Box
        component="main"
        sx={{
          ...styles.box1,
          mt: isMobile ? "48px" : 0,
          width: isMobile ? "100%" : undefined,
        }}
      >
        {showing_drawer(drawer_data)}
      </Box>
    </div>
  );
}

export default App;
